module.exports = __webpack_public_path__ + "static/media/img_membership_bg_02.36271ab6.png";